// レッスン・プログラムコンテンツのドメインサービス。レッスン・プログラム動画の取得・favなどを担う。
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LocalStorage } from '@lean-body/src/infra';
import { APISequences, } from '@lean-body/src/interfaces';
import { getCurrentUnixTimeInSeconds } from '@lean-body/src/util';
import { Equipment, LessonSession, Program, Trainer, } from '.';
import { VideoSrc } from './video';
export const HISTORY_PAGE_INIT = 0;
export const HISTORY_LIMIT_PER_PAGE = 20;
export const FAVORITE_PAGE_INIT = 0;
export const FAVORITE_LIMIT_PER_PAGE = 20;
/*=============================================
= Service =
=============================================*/
export class LessonService {
    constructor(apiClient, tracker, meRepo, config) {
        Object.defineProperty(this, "tracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meRepo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.apiClient = apiClient;
        this.tracker = tracker;
        this.meRepo = meRepo;
        this.config = config;
    }
    startLesson(lesson, lessonParent, courseLessonID) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { lessonId: lesson.id, CourseDaysLessonId: courseLessonID };
            if (lessonParent) {
                const isOriginalPlaylist = lessonParent.isOriginalPlaylist;
                if (!isOriginalPlaylist) {
                    params.programID = lessonParent.id;
                }
            }
            const sessionData = yield this.apiClient.startLessonSession(params);
            this.tracker.trackStartLesson(lesson, lessonParent);
            return new LessonSessionContext(new LessonSession(sessionData, this.config), this.apiClient, this.meRepo, this.tracker);
        });
    }
}
/*=============================================
= DomainModels =
=============================================*/
export class LessonSessionContext {
    constructor(session, apiClient, meRepo, tracker) {
        Object.defineProperty(this, "tracker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meRepo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "session", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoPlayAnalyzer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.tracker = tracker;
        this.meRepo = meRepo;
        this.apiClient = apiClient;
        this.session = session;
        this.meRepo.get().then((user) => {
            this.userId = user.id;
        });
        this.localStorage = new LocalStorage();
    }
    setVideoPlayAnalalyzor(analyzer) {
        this.videoPlayAnalyzer = analyzer;
    }
    get videoPlayStats() {
        if (this.videoPlayAnalyzer) {
            return this.videoPlayAnalyzer.stats;
        }
        return null;
    }
    get lesson() {
        return this.session.lesson;
    }
    get program() {
        return this.session.program;
    }
    susppend(time, lessonParent) {
        return __awaiter(this, void 0, void 0, function* () {
            this.tracker.trackSuspendLesson(this.userId, this.lesson, time, lessonParent);
        });
    }
    sync() {
        const stats = this.videoPlayStats;
        this.apiClient.syncLessonSession({
            sessionId: this.session.id,
            dedupedPlayDuration: stats.dedupedPlayDuration,
            playDurationRatio: stats.playDurationRatio,
            playDuration: stats.playDuration,
        });
    }
    // NOTE: lessonOrderIndex は isChallengeProgram が true の場合にのみサーバ側で使用されます
    quit(time, isAutoPlay, lessonOrderIndex, lessonParent, isChallengeProgram) {
        return __awaiter(this, void 0, void 0, function* () {
            const stats = this.videoPlayStats;
            if (stats) {
                this.tracker.trackQuitLesson(this.lesson, time, stats, this.userId, lessonParent, isAutoPlay);
                const next = yield this.apiClient.appendToSequence(APISequences.LESSON_FINISH_AND_PATCH_PROFILE);
                const lessonSessionData = yield this.apiClient.finishLessonSession({
                    sessionId: this.session.id,
                    completed: false,
                    dedupedPlayDuration: stats.dedupedPlayDuration,
                    playDurationRatio: stats.playDurationRatio,
                    playDuration: stats.playDuration,
                    lessonOrderIndex: lessonOrderIndex || 0,
                    isBelongToProgram: !!isChallengeProgram,
                });
                next();
                if (lessonSessionData.userSeasonAggregateData) {
                    this.localStorage.saveUserSeasonAggregateRank(lessonSessionData.userSeasonAggregateData);
                }
                return lessonSessionData;
            }
        });
    }
    // NOTE: lessonOrderIndex は isChallengeProgram が true の場合にのみサーバ側で使用されます
    complete(isAutoPlay, lessonOrderIndex, isChallengeProgram, lessonParent) {
        return __awaiter(this, void 0, void 0, function* () {
            const stats = this.videoPlayStats;
            if (stats) {
                this.tracker.trackCompleteLesson(this.lesson, stats, this.userId, lessonParent, isAutoPlay);
                const lessonSessionData = yield this.apiClient.finishLessonSession({
                    sessionId: this.session.id,
                    completed: true,
                    dedupedPlayDuration: stats.dedupedPlayDuration,
                    playDurationRatio: stats.playDurationRatio,
                    playDuration: stats.playDuration,
                    lessonOrderIndex: lessonOrderIndex || 0,
                    isBelongToProgram: !!isChallengeProgram,
                });
                // バッジ取得情報をBigQueryに送信
                lessonSessionData.badges.forEach((badge) => {
                    this.tracker.trackReceivedBadge(badge.id, badge.name, badge.type);
                });
                if (lessonSessionData.userSeasonAggregateData) {
                    this.localStorage.saveUserSeasonAggregateRank(lessonSessionData.userSeasonAggregateData);
                }
                return lessonSessionData;
            }
        });
    }
}
export var StyleID;
(function (StyleID) {
    StyleID[StyleID["LifeStyle"] = 9] = "LifeStyle";
})(StyleID || (StyleID = {}));
/*=============================================
= Entities =
=============================================*/
export class Lesson {
    constructor(lessonData, config) {
        var _a;
        Object.defineProperty(this, "minCal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxCal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "video", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "description", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "difficulty", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "duration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "equipments", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "heroSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "pace", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "programs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "programsLessons", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "style", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumbnailSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "trainers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endingStartSec", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "publishAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isComingSoon", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "orderIndex", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNew", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isDayOff", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "tags", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "lessonAggregate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isChecked", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isFavorite", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "courseLessonID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createdAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = lessonData.id;
        this.description = lessonData.description;
        this.difficulty = lessonData.difficulty;
        this.duration = lessonData.duration;
        this.equipments = (lessonData.equipments || []).map((d) => {
            return new Equipment(d, config);
        });
        this.heroSrc = lessonData.heroSrc;
        this.name = lessonData.name;
        this.pace = lessonData.pace;
        this.minCal = lessonData.minCal;
        this.maxCal = lessonData.maxCal;
        this.programs = lessonData.programs && lessonData.programs.map((v) => new Program(v, config));
        this.programs &&
            this.programs.forEach((program) => {
                program.lessons &&
                    program.lessons.forEach((lesson) => {
                        lesson.video = new VideoSrc(lesson.videoSrc, config);
                    });
            });
        this.programsLessons = lessonData.programsLessons;
        this.slug = lessonData.slug;
        this.style = lessonData.style;
        this.thumbnailSrc = lessonData.thumbnailSrc;
        this.trainers = lessonData.trainers && lessonData.trainers.map((v) => new Trainer(v, config));
        this.videoSrc = lessonData.videoSrc;
        this.video = new VideoSrc(lessonData.videoSrc, config);
        this.endingStartSec = (_a = lessonData.endingStartSec) !== null && _a !== void 0 ? _a : null;
        this.publishAt = lessonData.publishAt;
        this.orderIndex = lessonData.orderIndex;
        this.isDayOff = lessonData.isDayOff;
        this.isCompleted = lessonData.isCompleted;
        this.courseLessonID = lessonData.courseLessonId;
        this.tags = lessonData.tags;
        this.lessonAggregate = lessonData.lessonAggregate;
        this.createdAt = new Date(lessonData.createdAt);
        const currentUnixTime = getCurrentUnixTimeInSeconds();
        this.isComingSoon = currentUnixTime < this.publishAt;
        this.isChecked = false;
        this.isFavorite = lessonData.isFavorited;
        this.config = config;
    }
    get videoId() {
        return this.video.id;
    }
    get thumbnailURL() {
        return this.config.cdnBaseURL + this.thumbnailSrc;
    }
    get heroURL() {
        return this.config.cdnBaseURL + this.heroSrc;
    }
    get tagNameList() {
        return (this.tags || []).map((o) => `#${o.name}`);
    }
    get hasPrograms() {
        return this.programs.length > 0;
    }
    isFirstLesson() {
        return this.orderIndex === 1;
    }
    setIsChecked(isChecked) {
        this.isChecked = isChecked;
    }
}
